export default __webpack_public_path__ + "static/media/maleUser.70118f7c.svg";